import { render, staticRenderFns } from "./update-cpf.vue?vue&type=template&id=6409f856"
import script from "./update-cpf.vue?vue&type=script&lang=js"
export * from "./update-cpf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports